import { useLayoutEffect } from "react";

export const usePreventBrowserAutoScroll = (): void => {
    const top = window.scrollY;

    useLayoutEffect(() => {
        window.scrollTo({ top });
    });
};
